import axios from 'axios';

export default class ShopifyShippingProvider {
  /**
   *
   * @param {string} country
   * @param {string} province
   * @param {string} zip
   * @returns {ShopifyShippingRate}
   */
  static getShippingRates(country, province, zip) {
    return new Promise((resolve, reject) => {
      axios
        .get(
          `/cart/shipping_rates.json?shipping_address[country]=${country}&shipping_address[province]=${province}&shipping_address[zip]=${zip}`
        )
        .then(response => {
          resolve(response.data);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
}
